export default {
  title: 'Atalhos',
  links: {
    reservations: 'Reservas',
    orders_portal: 'Login no Terminal',
    closed: 'Fechado?',
    menu: 'Alterar menu',
    payouts: 'Relatórios de pagamentos',
    opening_hours: 'Horário de funcionamento',
  },
};
